// extracted by mini-css-extract-plugin
export default {"logo":"MainHeader_logo__cdXW9","user":"MainHeader_user__MU7Tm","logout":"MainHeader_logout__FSpdq","logout-btn":"MainHeader_logout-btn__kXR4J","header":"MainHeader_header__pwAdZ"};